<template>
  <div class="app-container offline-notify">
    <el-form :model="form" label-width="100px" class="form-box">
      <el-alert
        :closable="false"
        :style="{ margin: '0 0 30px 0' }"
        title="离线短信推动当前仅对电表项目有效！"
        type="warning"
        effect="dark"
        show-icon
      />
      <el-form-item label="离线短信推送">
        <el-switch
          v-model="form.ispush"
          v-loading="setPushEnableing"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
          class="push-enable__setting"
          active-value="1"
          active-text="启用"
          inactive-value="0"
          inactive-text="关闭"
          active-color="#1cc197"
          inactive-color="#ff4949"
          @change="setPushEnable"
        />
      </el-form-item>
      <el-form-item label="推送手机号1">
        <el-input v-model="form.smsmobile1" class="form-input" clearable>
          <el-button slot="append" class="btn-primary" :loading="setSmsMobileing" @click="setPushMobile">设置</el-button>
        </el-input>
      </el-form-item>
      <el-form-item label="推送手机号2">
        <el-input v-model="form.smsmobile2" class="form-input" clearable>
          <el-button slot="append" class="btn-primary" :loading="setSmsMobileing" @click="setPushMobile">设置</el-button>
        </el-input>
      </el-form-item>
      <el-form-item label="剩余短信[条]">
        <el-input v-model="form.smsremain" class="form-input" readonly>
          <el-button slot="append" class="btn-primary" @click="showSmsRechargeDialog = true">充值</el-button>
        </el-input>
      </el-form-item>
    </el-form>
    <SmsRechargeDialog :dialog-show.sync="showSmsRechargeDialog" @paysuccess="queryUserSetting()" />
  </div>

</template>

<script>
import { SwatchAlaramNotify, AlaramNotifySms } from '@/api/Alarms'
import { QueryUserAlarmSetting } from '@/api/Users'
import { Message } from 'element-ui'
import SmsRechargeDialog from '@/components/Recharge/sms/index.vue'
export default {
  name: 'OfflineNotify',
  components: { SmsRechargeDialog },
  data () {
    return {
      /** 短信推送表单设置 */
      form: {
        /** 是否启用/开通了离线短信推送 */
        ispush: '0',
        /** 推送手机号1 */
        smsmobile1: '',
        /** 推送手机号2 */
        smsmobile2: '',
        /** 剩余短信条数 */
        smsremain: 0
      },
      /** 显示短信充值模态框 */
      showSmsRechargeDialog: false,
      /** 设置是否开启短信推送中 */
      setPushEnableing: false,
      /** 设置推送手机号码中 */
      setSmsMobileing: false,
    }
  },
  created () {
    this.queryUserSetting()
  },
  methods: {
    /** 获取用户设置 */
    queryUserSetting () {
      QueryUserAlarmSetting().then(response => {
        this.queryUserSettingCall(response.data)
      })
    },
    /** 初始化表单/获取用户设置回调 */
    queryUserSettingCall (responseForm) {
      this.form.ispush = responseForm.ispush || '0'
      this.form.smsmobile1 = responseForm.smsmobiles[0]
      this.form.smsmobile2 = responseForm.smsmobiles[1]
      this.form.smsremain = responseForm.smsremain
    },
    /** 设置是否开启短信推送 */
    setPushEnable () {
      this.setPushEnableing = true
      SwatchAlaramNotify({
        enable: this.form.ispush
      }).then(response => {
        this.setPushEnableing = false
        const message = ['已关闭推送', '已开启推送']
        Message.success(message[this.form.ispush])
      }).catch(() => {
        Message.error('设置失败')
        const format = ['1', '0']
        this.form.ispush = format[this.form.ispush]
        this.setPushEnableing = false
      })
    },
    /** 设置推动手机号 */
    setPushMobile () {
      this.setSmsMobileing = true
      const postData = [
        this.form.smsmobile1,
        this.form.smsmobile2
      ]
      AlaramNotifySms({ phone: postData })
        .then(response => {
          this.setSmsMobileing = false
          Message.success('推送手机号码设置成功')
        }).catch(() => {
          Message.error('推送手机号码设置失败')
          this.setSmsMobileing = false
        })
    },
  }
}

</script>
<style lang='stylus' scoped>
.offline-notify
  position: absolute
  background-color: #1d3666
  top: 0
  bottom: 0
  left: 0
  right: 0
  .form-box
    position: absolute
    background-color: #0b245b
    border-radius: 5px
    height: fit-content
    width: fit-content
    padding: 30px 50px
    top: -100px
    right: 0
    bottom: 0
    left: 0
    margin: auto
  .form-input
    width: 500px
  .btn-primary
    background-color: #1cc197
    border-color: #1cc197
    border-top-left-radius: 0
    border-bottom-left-radius: 0
</style>

<style lang='stylus'>
.offline-notify
  .push-enable__setting
    .el-switch__label--left
      color: #ff4949 !important
    .el-switch__label--right
      color: #1cc197 !important
    .el-loading-spinner
      margin-top: -10px
  .form-input
    input
      border-color: #1cc197
      background-color: #1d3666
      color: white
    .el-input-group__append
      border-color: #1cc197
      color: white
</style>
